<ion-header>
  <ion-toolbar>
    <ion-title>{{ texts.filter.title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-header>
  <mat-selection-list>
    <ion-item lines="none">
      <mat-list-option
        (click)="onToggleAll()"
        [selected]="oneSelected$ | async">
        <div mat-line>{{ texts.general.selectAll | translate }}</div>
      </mat-list-option>
    </ion-item>
  </mat-selection-list>
</ion-header>
<ion-content>
  <mat-selection-list>
    <ion-item *ngFor="let col of list$ | async; let i = index">
      <mat-list-option (click)="onSelection(i)" [selected]="col.selected">
        <div mat-line>
          {{ col?.name | translate }}
        </div>
      </mat-list-option>
    </ion-item>
  </mat-selection-list>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-tab-button (click)="handleOnSave()">
          <ion-icon name="save"></ion-icon>
          <ion-label>
            {{ texts.general.save | translate }}
          </ion-label>
        </ion-tab-button>

        <ion-tab-button (click)="handleOnCancel()">
          <ion-icon name="arrow-back"></ion-icon>
          <ion-label>{{ texts.general.cancel | translate }}</ion-label>
        </ion-tab-button>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
